export enum GTMEvent {
  Vault = 'vaultEvent',
}

export interface IGTMPayload {
  event: GTMEvent;
  action: string;
  value?: any;
}

export interface IGTMVaultPayload {
  action: string;
  value?: any;
}

export const gtmVaultEvent = (payload: IGTMVaultPayload) => {
  const { dataLayer } = window;
  if (!dataLayer) {
    console.warn('[QA] GTM not yet initialized');
    return;
  }
  dataLayer.push({
    ...payload,
    event: GTMEvent.Vault,
  });
};
